import { Action, createAction, handleActions } from "redux-actions";
import {
  GetNovedadResponse,
  GetNovedadesRequest,
  GetNovedadesResponse,
} from "~api/types";
import { FechaFiltro, FiltroValue, Services, TakeValue } from "../types";

interface GetNovedadesCompletedPayload {
  novedades: GetNovedadResponse[];
  totalRegistros: number;
  isAnOldRequest?: boolean;
}

interface CurrentNovedadPayload {
  currentNovedad: GetNovedadResponse | null;
}

interface NovedadesState {
  novedades: GetNovedadResponse[] | null;
  currentUsuario: GetNovedadResponse | null;
  isLoading: boolean;
  failed: boolean;
  totalRegistros: number;
}

interface GetNovedadesParams {
  skip: number;
  take: TakeValue;
  fechaNovedadDesde?: FechaFiltro;
  fechaNovedadHasta?: FechaFiltro;
  inicioVigenciaDesde?: FechaFiltro;
  inicioVigenciaHasta?: FechaFiltro;
  searchCriteria?: FiltroValue;
  negocio?: FiltroValue;
  compania?: FiltroValue;
  tipoNovedad?: FiltroValue;
}

const setInitialState = createAction("SET_NOVEDADES_INITIAL_STATE");

const setCurrentNovedad = createAction(
  "SET_CURRENT_USUARIO",
  (currentNovedad: GetNovedadResponse | null): CurrentNovedadPayload => ({
    currentNovedad,
  })
);

const getNovedadesInited = createAction("OBTENER_NOVEDADES_INITED");

const getNovedadesCompleted = createAction(
  "OBTENER_NOVEDADES_COMPLETED",
  (
    response: GetNovedadesResponse | null | undefined,
    isAnOldRequest?: boolean
  ): GetNovedadesCompletedPayload => {
    let novedades: GetNovedadResponse[] = [];
    let totalRegistros = 0;

    if (response != null) {
      novedades = response.novedades;
      totalRegistros = response.totalRegistros;
    }

    return { novedades, totalRegistros, isAnOldRequest };
  }
);
const getNovedadesFailed = createAction(
  "OBTENER_NOVEDADES_FAILED",
  (error: unknown) => ({
    error,
  })
);

const getNovedades = ({
  skip,
  take,
  fechaNovedadDesde,
  fechaNovedadHasta,
  inicioVigenciaDesde,
  inicioVigenciaHasta,
  searchCriteria,
  negocio,
  compania,
  tipoNovedad,
}: GetNovedadesParams) => {
  return async (
    dispatch: (action: any) => void,
    getState: () => any,
    services: Services
  ) => {
    try {
      dispatch(getNovedadesInited());

      // Las fechas llegan como Date, o vacías cuando el filtro no se usó: el
      // armado de la petición ya descarta lo vacío.
      const data: GetNovedadesRequest = {
        skip,
        take: Number(take),
        searchCriteria: searchCriteria ? String(searchCriteria) : undefined,
        fechaNovedadDesde: fechaNovedadDesde as Date | undefined,
        fechaNovedadHasta: fechaNovedadHasta as Date | undefined,
        inicioVigenciaDesde: inicioVigenciaDesde as Date | undefined,
        inicioVigenciaHasta: inicioVigenciaHasta as Date | undefined,
        negocio: negocio ? String(negocio) : undefined,
        compania: compania ? String(compania) : undefined,
        tipoNovedad: tipoNovedad ? String(tipoNovedad) : undefined,
      };
      const response = await services.api.novedades().getNovedades(data);

      dispatch(getNovedadesCompleted(response));
    } catch (error) {
      console.error(error);
      dispatch(getNovedadesFailed(error));
    }
  };
};

const novedadesInitialState: NovedadesState = {
  novedades: null,
  currentUsuario: null,
  isLoading: false,
  failed: false,
  totalRegistros: 0,
};

const novedadesReducer = handleActions<NovedadesState, any>(
  {
    [setInitialState.toString()]: (): NovedadesState => {
      return {
        ...novedadesInitialState,
        novedades: null,
      };
    },
    [setCurrentNovedad.toString()]: (
      state: NovedadesState,
      action: Action<CurrentNovedadPayload>
    ): NovedadesState => {
      return {
        ...state,
        currentUsuario: action.payload.currentNovedad,
      };
    },
    [getNovedadesInited.toString()]: (
      state: NovedadesState
    ): NovedadesState => {
      return {
        ...state,
        totalRegistros: 0,
        isLoading: true,
      };
    },
    [getNovedadesCompleted.toString()]: (
      state: NovedadesState,
      action: Action<GetNovedadesCompletedPayload>
    ): NovedadesState => {
      return {
        ...state,
        novedades: action.payload.novedades,
        totalRegistros: action.payload.totalRegistros,
        isLoading: false,
        failed: false,
      };
    },
    [getNovedadesFailed.toString()]: (
      state: NovedadesState
    ): NovedadesState => {
      return {
        ...state,
        isLoading: false,
        failed: true,
      };
    },
  },
  novedadesInitialState
);

export { novedadesReducer };
export { getNovedades, setInitialState, setCurrentNovedad };
